import useMediaQuery from './useMediaQuery';

/**
 * True when the visitor has asked their OS to reduce motion.
 *
 * The site's signature effect is full-viewport random static at 10fps on
 * every page transition, plus per-card noise on hover. High-contrast
 * random flicker is a genuine health concern for photosensitive visitors,
 * not just a stylistic preference, so every canvas animation checks this
 * before it starts a requestAnimationFrame loop.
 */
const useReducedMotion = (): boolean =>
    useMediaQuery('(prefers-reduced-motion: reduce)');

export default useReducedMotion;
